export const STAFFING_DATA = "STAFFING_DATA";
export const ITENERARIES = "ITENERARIES";
export const CAPACITY_PLANS = "CAPACITY_PLANS";
export const CAPACITY_IMPLEMENTED = "CAPACITY_IMPLEMENTED";
export const COMPLAINTS = "COMPLAINTS";
export const SET_ADMINISTRATIVE = "SET_ADMINISTRATIVE";
